import { request } from "../request";

export const getAllLocations = (params) => {
	return request({
		method: 'post',
		url: '/locations/getallbyadmin',
		params
	})
}
export const addLocation = (params) => {
	return request({
		method: 'post',
		url: '/locations/adminAdd',
		params
	})
}
export const deleteLocation = (params) => {
	return request({
		method: 'post',
		url: '/locations/adminDelete',
		params
	})
}